<template>
  <v-container>
    <v-skeleton-loader
      :loading="skeleton"
      class="mx-auto"
      max-height="970"
      type="list-item-three-line@6, actions, divider"
    >
      <form v-if="edit">      
        <!-- <v-container>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-select
                v-model="form.title_lookup_uid"
                :items="title"
                data-vv-name="title_lookup_uid"
                data-vv-as="title"            
                item-text="value"
                item-value="lookup_uid"
                label="Title"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field  
                v-model="form.alias"
                :error-messages="errors.collect('alias')"
                data-vv-name="alias"
                label="Alias"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field            
                v-model="form.name"
                v-validate="'required|max:255'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
                label="Name"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field  
                v-model="email"
                v-validate="'email'"
                :error-messages="errors.collect('email')"
                data-vv-name="email"
                label="Email"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field
                v-model="ic"
                v-mask="mask"
                v-validate="'required'"
                :error-messages="errors.collect('ic')"
                data-vv-name="ic"
                data-vv-as="ic number"
                label="IC Number"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-select
                v-model="form.gender_lookup_uid"
                :items="gender"
                data-vv-name="gender_lookup_uid"   
                data-vv-as="gender"
                item-text="value"
                item-value="lookup_uid"
                label="Gender"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-select
                v-model="form.ethnicity_lookup_uid"
                :items="ethnicity"
                data-vv-name="ethnicity_lookup_uid"
                data-vv-as="ethnicity"
                item-text="value"
                item-value="lookup_uid"
                label="Ethnicity"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-select
                v-model="form.marital_status_lookup_uid"
                :items="marital_status"
                data-vv-name="marital_status_lookup_uid"   
                data-vv-as="marital status"
                item-text="value"
                item-value="lookup_uid"
                label="Marital Status"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-select
                v-model="form.religion_lookup_uid"
                :items="religion"
                data-vv-name="religion_lookup_uid"
                data-vv-as="religion"
                item-text="value"
                item-value="lookup_uid"
                label="Religion"
              />
            </v-col>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-select
                v-model="form.dob_state_lookup_uid"
                :items="place_of_birth" 
                data-vv-name="dob_state_lookup_uid"       
                data-vv-as="place of birth" 
                item-text="value"
                item-value="lookup_uid"
                label="Place of Birth"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col 
              cols="12" 
              md="6"
            >
              <v-text-field
                v-model.number="form.no_of_dependent"
                v-validate="'required|dependentsValue'"
                :error-messages="errors.collect('dependents')"
                data-vv-name="dependents"
                data-vv-as="dependents"
                type="number"
                label="Dependents"
              />
            </v-col>
          </v-row>
        </v-container> -->
      </form>
      <div v-else>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-format-title
            </v-icon>
            <span class="font-weight-medium">Title:</span>
          </v-col>
          <v-col>
            {{ titleValue }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-human-male-female
            </v-icon>
            <span class="font-weight-medium">Gender:</span>
          </v-col>
          <v-col>
            {{ genderValue }}
          </v-col>
        </v-row>  
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-account-box-outline
            </v-icon>
            <span class="font-weight-medium">Name:</span>
          </v-col>
          <v-col>
            {{ person.name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-account-box
            </v-icon>
            <span class="font-weight-medium">Alias:</span>
          </v-col>
          <v-col>
            {{ person.alias }}
          </v-col>
        </v-row> 
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-email
            </v-icon>
            <span class="font-weight-medium">Email:</span>
          </v-col>
          <v-col>
            {{ employee.email }}
          </v-col>
        </v-row> 
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-account-group
            </v-icon>
            <span class="font-weight-medium">Ethnicity:</span>
          </v-col>
          <v-col>
            {{ ethnicityValue }}
          </v-col>
        </v-row>  
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-account-card-details
            </v-icon>
            <span class="font-weight-medium">IC Number:</span>
          </v-col>
          <v-col>
            <span>{{ icNumber | icFormat }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-church
            </v-icon>
            <span class="font-weight-medium">Religion:</span>
          </v-col>
          <v-col>
            {{ religionValue }}
          </v-col>
        </v-row>     
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-cake-variant
            </v-icon>
            <span class="font-weight-medium">Date Of Birth:</span>
          </v-col>
          <v-col>
            {{ person.dob }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-heart
            </v-icon>
            <span class="font-weight-medium">Marital Status:</span>
          </v-col>
          <v-col>
            {{ maritalValue }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-city
            </v-icon>
            <span class="font-weight-medium">Place Of Birth:</span>
          </v-col>
          <v-col>
            {{ placeOfBirthValue }}
          </v-col>
        </v-row>
        <v-row>
          <v-col 
            cols="12"
            sm="6" 
            lg="5"
            xl="3"
          >
            <v-icon class="mr-2">
              mdi-account-multiple-plus
            </v-icon>
            <span class="font-weight-medium">Dependents:</span>
          </v-col>
          <v-col>
            {{ person.no_of_dependent }}
          </v-col>
        </v-row>
      </div>  
      <!-- <v-card-actions v-if="$hasPermissionTo(['update whole persons']) || $store.state.isMyProfile">
        <v-spacer />
        <v-btn
          v-if="!edit"
          color="info"
          @click="editForm"
        >
          Edit
        </v-btn>
        <div v-else>
          <v-btn
            :disabled="progressing"
            text
            @click="edit = false"
          >
            Cancel
          </v-btn>
          <v-btn          
            :loading="progressing"
            color="success"
            @click="submitForm"
          >
            Update
          </v-btn>
        </div>
      </v-card-actions> -->
      <v-divider />
    </v-skeleton-loader>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    inject: ['$validator'],
    filters: {
      icFormat: function (value) {
        if (!value) return ''
      
        value = value.toString()
        return `${value.slice(0, 6)}-${value.slice(6, 8)}-${value.slice(8, 12)}`
      },
    },
    props: {
      personUid: {
        type: String,
        default: '',
      },
      employeeUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        skeleton: true,
        progressing: false,
        edit: false,
        person: {},
        employee: {},
        email: null,
        mask: '######-##-####',
        ic: null,
        form: {
          title_lookup_uid: '',
          dob_state_lookup_uid: '',
          marital_status_lookup_uid: '',
          religion_lookup_uid: '',
          ethnicity_lookup_uid: '',
          name: '',
          alias: '',
          no_of_dependent: 0,
          gender_lookup_uid: '',
        },
      }
    },
    computed: {
      ...mapState('lookup', ['title', 'gender', 'ethnicity', 'religion', 'marital_status', 'place_of_birth']),   
      titleValue () {
        return (this.title.find(title => {
          return title.lookup_uid === this.person.title_lookup_uid
        }) || {}).value || ''
      },
      genderValue () {
        return (this.gender.find(gender => {
          return gender.lookup_uid === this.person.gender_lookup_uid
        }) || {}).value || ''
      },
      ethnicityValue () {
        return (this.ethnicity.find(ethnicity => {
          return ethnicity.lookup_uid === this.person.ethnicity_lookup_uid
        }) || {}).value || ''
      },
      religionValue () {
        return (this.religion.find(religion => {
          return religion.lookup_uid === this.person.religion_lookup_uid
        }) || {}).value || ''
      },
      maritalValue () {
        return (this.marital_status.find(marital => {
          return marital.lookup_uid === this.person.marital_status_lookup_uid
        }) || {}).value || ''
      },
      placeOfBirthValue () {
        return (this.place_of_birth.find(placeOfBirth => {
          return placeOfBirth.lookup_uid === this.person.dob_state_lookup_uid
        }) || {}).value || ''
      },
      icNumber () {
        return (this.person.identity_card || {}).ic_number || ''
      },
    },
    watch: {
      personUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadPerson()
          }
        },
      },
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadEmployee()
          }
        },
      },
    },
    mounted () {
      let scope = this

      this.$validator.extend('dependentsValue', {
        getMessage (field, args) {
          return 'Invalid Number of Dependents'
        },
        validate (value, args) {
          return scope.isValidDependents(value)
        },
      })
    }, 
    methods: {    
      loadEmployee () {
        this.$api.employees().show(this.employeeUid)
          .then(response => {
            this.employee = response.data
          })
      },
      loadPerson () {
        this.$api.persons().show(this.personUid)
          .then(response => {
            this.person = response.data          
          })
          .catch(() => {})
          .then(() => {
            this.skeleton = false
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            Promise.all([
              this.$api.persons().update(this.personUid, this.form),
              this.$api.employees().updateEmail(this.employeeUid, this.prepareEmailData()),
              this.$api.identityCards().update(this.person.person_uid, { ic_number: this.ic.replace(/-/g, '') }),
            ])
              .then(([person, employee]) => {
                if (person.status >= 200 && person.status < 300) {
                  Object.keys(this.form).map(key => {
                    this.$set(this.person, key, this.form[key])
                  })

                  this.edit = false

                  this.$snack({
                    message: person.data.status,
                  })
                }
              }).catch((e) => {
                if (e.response.status === 409) {
                  this.$snack({ 
                    color: 'error',
                    message: e.response.data.message, 
                  })
                }
              })
              .then(() => {
                this.progressing = false
                this.loadEmployee()
                this.loadPerson()
              })
          })
      },
      prepareEmailData () {
        if (this.employee.email) {
          if (this.email) {
            return {
              email: this.email,
            }
          }
          return {
            email: this.employee.email,
          }
        }

        return {
          email: this.email,
        }
      },
      editForm () {
        Object.keys(this.form).map(key => {
          this.form[key] = this.person[key]
        })

        this.email = this.employee.email
        this.ic = this.person.identity_card.ic_number

        this.edit = true
      },
      isValidDependents (value) {
        return value >= 0
      },
    },
  }
</script>
